import React from 'react';
import type { PiPublicArticle } from '../../patient-invisalign-public/types';
import { Icon } from '../Icon/Icon';

export interface PiPublicArticleCardProps {
  article: PiPublicArticle;
}

export function PiPublicArticleCard({ article }: PiPublicArticleCardProps) {
  return (
    <div className="flex flex-1 flex-col items-start justify-center gap-5 rounded-[var(--r-xl)] border border-[color-mix(in_srgb,var(--ai-4)_18%,var(--cream-2))] bg-[var(--cream-1)] p-2 pb-4">
      <div className="w-full overflow-hidden rounded-[var(--r-xl)]">
        <img src={article.image} alt={article.imageAlt} className="h-auto w-full object-cover" />
      </div>
      <div className="flex flex-col gap-2 px-2">
        <h3 className="m-0 text-base font-semibold text-[var(--ink-0)]">{article.title}</h3>
        <p className="m-0 text-xs text-[var(--ink-2)]">{article.description}</p>
        <span className="mt-1 inline-flex items-center gap-1 text-xs font-medium text-[var(--success)]">
          Read article
          <Icon kind="arrow-r" size={14} />
        </span>
      </div>
    </div>
  );
}
